import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

const Solutions = () => {
    const { useLang, isMobile } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    return (
        <div
            className={`${styles.solutions} GtmModuleData-section`}
            id="Solutions"
            data-section-id={styles.solutions}
            data-section-title={t(`solutions_title`)}
        >
            <div className="banner-container">
                <EcoImg
                    pc={'https://websiteoss.ecoflow.com/upload/image/1761272023401/solutions-pc.jpg'}
                    pad="https://websiteoss.ecoflow.com/upload/image/1761273198110/solutions-h5.jpg"
                    alt={t('solutions_title')}
                    isOpenLazy={true}
                    className="banner"
                />
                <div className="text-container">
                    <h2>{t(`solutions_title`)}</h2>
                    <p className="intro">{t(`solutions_intro`)}</p>
                </div>
            </div>
            <div className="content">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{isMobile ? t(`solutions_ocean_h5`) : t(`solutions_ocean`)}</th>
                            <th>{isMobile ? t(`solutions_dpux_h5`) : t(`solutions_dpux`)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{t(`solutions_q1`)}</td>
                            <td>
                                {t.rich(`solutions_a1_ocean`, {
                                    b: (text: string) => <span className="text1">{text}</span>,
                                })}
                            </td>
                            <td>
                                {t.rich(`solutions_a1_dpux`, {
                                    b: (text: string) => <span className="text1">{text}</span>,
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td>{t(`solutions_q2`)}</td>
                            <td className="grid">
                                <EcoImg
                                    pc={'https://websiteoss.ecoflow.com/upload/image/1761189403430/icon-ongrid.png'}
                                    alt={t('solutions_a1_ocean')}
                                    className="icon"
                                />
                                {t(`solutions_a2_ocean`)}
                            </td>
                            <td className="grid">
                                <EcoImg
                                    pc={'https://websiteoss.ecoflow.com/upload/image/1761189369631/icon-offgrid.png'}
                                    alt={t('solutions_a1_dpux')}
                                    className="icon"
                                />
                                {t(`solutions_a2_dpux`)}
                            </td>
                        </tr>
                        <tr>
                            <td>{t(`solutions_q3`)}</td>
                            <td className="li-box">
                                {t.rich(`solutions_a3_ocean`, {
                                    span: (text: string) => <span>{text}</span>,
                                    p: (text: string) => <p className="text2">{text}</p>,
                                })}
                            </td>
                            <td className="li-box">
                                {t.rich(`solutions_a3_dpux`, {
                                    span: (text: string) => <span>{text}</span>,
                                    p: (text: string) => <p className="text2">{text}</p>,
                                })}
                            </td>
                        </tr>
                        <tr>
                            <td>{t(`solutions_q4`)}</td>
                            <td>{t(`solutions_a4_ocean`)}</td>
                            <td>{t(`solutions_a4_dpux`)}</td>
                        </tr>
                        <tr>
                            <td>{t(`solutions_q5`)}</td>
                            <td>{t(`solutions_a5_ocean`)}</td>
                            <td>{t(`solutions_a5_dpux`)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Solutions;
